module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-pid-modal"
  }, [_c('modal', {
    ref: "modal",
    attrs: {
      "autoWidth": "",
      "closeButton": "",
      "width": 400
    },
    on: {
      "closed": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "download-pid-modal__modal center"
  }, [_c('div', {
    staticClass: "download-pid-modal__header-menu"
  }, [_c('h2', {
    staticClass: "download-pid-modal__header"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('h4', {
    staticClass: "download-pid-modal__target-name",
    attrs: {
      "title": _vm.target.display_name
    }
  }, [_vm._v(_vm._s(_vm.target.display_name))]), _vm._v(" "), (_vm.load) ? _c('div', {
    staticClass: "center"
  }, [_c('loading-dots')], 1) : (!_vm.hasPidLists) ? _c('span', [_vm._v("No PID lists found for target!")]) : _c('table', [_c('thead', [_c('tr', [_c('th', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.onSelectAll
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Filename")]), _vm._v(" "), _c('th', {
    staticClass: "file-extension"
  }, [_vm._v("Type")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.localPidLists), function(list) {
    return _c('tr', [_c('td', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (list.selected),
        expression: "list.selected"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(list.selected) ? _vm._i(list.selected, null) > -1 : (list.selected)
      },
      on: {
        "change": function($event) {
          var $$a = list.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(list, "selected", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(list, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(list, "selected", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(((_vm.target.display_name) + "_" + (list.suffix))))]), _vm._v(" "), _c('td', {
      staticClass: "file-extension"
    }, [_vm._v(_vm._s(_vm.getFileExtension(list.name)))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "download-pid-modal__button center"
  }, [_c('action-button', {
    attrs: {
      "disabled": !_vm.buttonClickable,
      "color": "success",
      "label": "Download PID Lists",
      "id": "downloadPidListsBtn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.download.apply(null, arguments)
      }
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc9f5c46","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/components/DownloadPidListModal.vue
// module id = 2186
// module chunks = 0